export class DateRangeModel {
  constructor (
    public fromDate?: Date | string,
    public toDate?: Date | string
  ) {}
}
